module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-04-99a5a919.jpg";